module.exports = __webpack_public_path__ + "static/media/shop_card_bg.258385d2.png";